export default function initials(nameString) {
  const initialsMatch = nameString.match(/\b\w/g);
  return (initialsMatch || []);
}
